import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, PawPrint, Plus } from 'lucide-react';
import BottomNavigation from '../components/BottomNavigation';
import LanguageToggle from '../components/LanguageToggle';
import NotificationBell from '../components/NotificationBell';
import LostFoundList from '../components/LostFoundList';

// Feb 2026 — Lost & Found now lives inside the Community Safety Hub. This is
// the dedicated list page, reusing the existing LostFoundList component and
// backend endpoints untouched.  Reachable from:
//   • /lost-found                          (new canonical route)
//   • Community Safety Hub → "Lost & Found" card
//   • Community Safety Hub → "+ Create Community Post" → "Lost / Found something"
// The old /classifieds?section=lostfound URL keeps working via redirect.
const LostFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 pb-24" data-testid="lost-found-page">
      <header className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate('/community-safety')}
              className="p-2 rounded-lg hover:bg-white/20"
              data-testid="lost-found-back-btn"
              aria-label={t('back', 'Back')}
            >
              <ArrowLeft className="h-5 w-5 rtl-flip" />
            </button>
            <div>
              <h1 className="text-xl font-bold flex items-center gap-2" data-testid="lost-found-title">
                <PawPrint className="h-5 w-5" /> {t('lostFound.title', 'Lost & Found')}
              </h1>
              <p className="text-xs text-blue-100">
                {t('lostFound.subtitle', 'Help reunite items with their owners across your community.')}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <NotificationBell variant="on-purple" />
            <LanguageToggle />
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto">
        <LostFoundList onPost={() => navigate('/lost-found/post')} />
      </main>

      <button
        onClick={() => navigate('/lost-found/post')}
        className="fixed bottom-24 right-4 z-40 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg transition-all hover:scale-105"
        data-testid="post-lf-fab"
        aria-label={t('lostFound.postCta', 'Post a Lost or Found item')}
      >
        <Plus className="h-6 w-6" />
      </button>
      <BottomNavigation />
    </div>
  );
};

export default LostFound;
